import { schema } from 'normalizr';

export const toxProfileChapterSchema = new schema.Entity(
  'toxProfileChapters',
  {},
  { idAttribute: 'ToxProfileChapterId' },
);
export const toxProfileChapterListSchema = [toxProfileChapterSchema];
